import { render, staticRenderFns } from "./AOC.vue?vue&type=template&id=bc7643fa&scoped=true&"
import script from "./AOC.vue?vue&type=script&lang=js&"
export * from "./AOC.vue?vue&type=script&lang=js&"
import style0 from "./AOC.vue?vue&type=style&index=0&id=bc7643fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7643fa",
  null
  
)

export default component.exports